import useFiltersPayload from './hooks/useFiltersPayload';
import useInitialization from './hooks/useInitialization';
import useQueryStringPersist from './hooks/useQueryStringPersist';
import useStoragePersist from './hooks/useStoragePersist';

const ContextHooksWrapper = ({ Context, withInitialFilters }) => {
  useFiltersPayload({
    Context
  });

  useStoragePersist({ Context });

  useQueryStringPersist({ Context });

  useInitialization({
    Context,
    withInitialFilters
  });

  return null;
};

export default ContextHooksWrapper;
